import axios from "../../axios/ctiConfig";
import ctiRequest from "../../axios/ctiRequests";

import * as actionTypes from "./actionTypes";
import { localStorageFunc, notify} from "../../helpers/utility";


//Validation Agent
export const agentValidateStart = () =>{
  return {
    type: actionTypes.AGENT_VALIDATE_START,
  }
}
export const agentValidateSuccess = (isExpired, responseCode, reason) =>{
  localStorageFunc.set("isExpired", isExpired);
  localStorageFunc.set("responseCode", responseCode);
  localStorageFunc.set("reason", reason);
  return {
    type: actionTypes.AGENT_VALIDATE_SUCCESS,
    isExpired: isExpired,
    responseCode: responseCode,
    reason: reason,
    
  }
}
export const agentValidateFail = (isExpired,responseCode,reason) =>{
  localStorageFunc.set("isExpired", isExpired);
  localStorageFunc.set("responseCode", responseCode);
  return {
    type: actionTypes.AGENT_VALIDATE_FAIL,
    isExpired: isExpired,
    responseCode: responseCode,
     reason: reason,
  }
}
//Agent Change Password

export const changeAgentPasswordStart = () =>{
  return{
    type: actionTypes.AGENT_PASSWORD_Start,
  }
}

export const changeAgentPasswordSuccess = (responseCode,reason)=>{
  localStorageFunc.set("responseCode", responseCode);
  localStorageFunc.set("reason", reason);
  return {
   type: actionTypes.AGENT_PASSWORD_SUCCESS,
    responseCode: responseCode,
    reason: reason,
  }
}

export const changeAgentPassowordFail = (responseCode, error) =>{
  localStorageFunc.set("responseCode", responseCode);
  localStorageFunc.set("Reseterror", error);
  return {
    type: actionTypes.AGENT_PASSWORD_FAIL,
    responseCode: responseCode,
    error: error,
  }
}


export const checkValidateAgent = (email) =>{
    return(dispatch)=>{
      dispatch(agentValidateStart());
      ctiRequest["VALIDATE_AGENT"].agent_id = email;
      axios
      .post("/", ctiRequest["VALIDATE_AGENT"])
      .then((result) =>{
        if(result.data.response.status === "SUCCESS"){
          dispatch(agentValidateSuccess(false, result.data.response.response_code,result.data.response.reason ))
             
        }
        else{
        if(result.data.response.is_agent_exist === "0"){
       dispatch(agentValidateFail(false,result.data.response.response_code,result.data.response.reason));
          }
         else{
          dispatch(agentValidateFail(true,result.data.response.response_code,result.data.response.reason));
        }
      }
      })
      .catch((err) =>{
        notify("Validate Error - " + err, "network-error");
                // dispatch(agentLoginFail(err));
      })
    }
  }
  
  export const changeAgentPassword = (email,currPassword, newPassword, conPassword) =>{
    return(dispatch) =>{
      dispatch(changeAgentPasswordStart());
      ctiRequest["CHANGE_AGENT_PASSWORD"].agent_id = email;
      ctiRequest["CHANGE_AGENT_PASSWORD"].current_password = currPassword;
      ctiRequest["CHANGE_AGENT_PASSWORD"].new_password = newPassword;
      ctiRequest["CHANGE_AGENT_PASSWORD"].confirm_password = conPassword;
      axios
      .post("/", ctiRequest["CHANGE_AGENT_PASSWORD"])
      .then((result) =>{
        if(result.data.response.status === "SUCCESS"){
          dispatch(changeAgentPasswordSuccess(result.data.response.response_code, result.data.response.reason))
        }
        else{
            notify(result.data.response.reason)
          dispatch(changeAgentPassowordFail(result.data.response.response_code, result.data.response.reason ))
        }
      })
      .catch((err) =>{
        notify("Reset Error - " + err, "network-error");
               // dispatch(agentLoginFail(err));
     })
    }
  }